import { Injectable } from '@angular/core';
import { HttpClient, HttpEventType,HttpHeaders } from '@angular/common/http';
import { TokenService } from '../../token.service';
import { MainService } from './main.service';
@Injectable({
  providedIn: 'root'
})
export class TenderService {

  httpUrl;
  constructor(private http: HttpClient, private main: MainService, private token:TokenService) {
    this.httpUrl = this.main.httpUrl;
  }

  //BOQ
  async getGeometry(acct_id:any){
    const resp= this.http.get<any>(this.main.httpUrl+'/info/geometry/getgeometry'+acct_id ).toPromise().then(res =>{
      return res
    });
    return resp
  }
  async createBoq(obj:any) {
    const resp = await this.http.post<any>(this.main.httpUrl + '/info/boq/createTender', obj  ).toPromise().then(res => {
      return res;
    });
    return resp;

  }
  async getBoq(obj:any) {
    const resp = await this.http.get<any>(this.main.httpUrl + '/info/boq/getTender' + obj  ).toPromise().then(res => {
      return res;
    });
    return resp;

  }
  async getAllTender(obj:any) {
    const resp = await this.http.get<any>(this.main.httpUrl + '/info/boq/getAllTender' + obj  ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async getItem(obj:any) {
    const resp = await this.http.get<any>(this.main.httpUrl + '/info/boq/getItem' + obj  ).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async getLastEMB(obj:any) {
    const resp = await this.http.get<any>(this.main.httpUrl + '/info/emb/getLastEMB' + obj  ).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async deleteBoq(obj:any) {
    const resp = await this.http.delete<any>(this.main.httpUrl + '/info/boq/deleteTender' + obj  ).toPromise().then(res => {
      return res;
    });
    return resp;

  }
  async updateUnit(ob:any) {
    const resp = await this.http.put<any>(this.main.httpUrl + '/info/boq/updateItem', ob ).toPromise().then(res => {
      return res;
    });
    return resp;

  }
  async getHeadRecord(obj:any){
    const resp= this.http.get<any>(this.main.httpUrl+'/info/head/getheadDetails'+obj ).toPromise().then(res =>{
      return res
    });
    return resp
  }
  async updateAlreadyMeasured(ob:any) {
    const resp = await this.http.put<any>(this.main.httpUrl + '/info/boq/updateAlreadyMeasured', ob ).toPromise().then(res => {
      return res;
    });
    return resp;

  }
  async changestatus(obj:any) {
    const resp = await this.http.put<any>(this.main.httpUrl + '/info/boq/changestatus', obj  ).toPromise().then(res => {
      return res;
    });
    return resp;

  }
  async getPaySchedule(obj:any) {
    const resp = await this.http.get<any>(this.main.httpUrl + '/info/boq/getpaySchule' + obj  ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async updaterate(obj:any) {
    const resp = await this.http.put<any>(this.main.httpUrl + '/info/boq/updaterate', obj  ).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async updateBoq(obj:any) {
    const resp = await this.http.put<any>(this.main.httpUrl + '/info/boq/updateTender', obj  ).toPromise().then(res => {
      return res;
    });
    return resp;

  }

}
